const HIDDEN_KEYS = new Set([
  '_id',
  'tenantId',
  'tenant',
  'accountingClient',
  'sourceId',
  'createdBy',
  'shipmentType',
  '__v',
  'createdAt',
  'updatedAt',
]);

const isPlainObject = (value) =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const resolveAccount = (value, accountMap) => {
  if (value === null || value === undefined) return value;

  const id =
    typeof value === 'object' && value !== null
      ? String(value._id || value.$oid || value)
      : String(value);

  return (accountMap && accountMap[id]) || id;
};

/**
 * Recursively strips audit-internal fields from a JournalEntry snapshot/change
 * value and resolves `account` ObjectIds to "CODE — Name" display strings.
 * Never mutates its input; always returns new arrays/objects.
 */
const sanitizeAuditSnapshot = (data, accountMap = {}) => {
  if (Array.isArray(data)) {
    return data.map((item) => sanitizeAuditSnapshot(item, accountMap));
  }

  if (isPlainObject(data)) {
    const result = {};
    Object.keys(data).forEach((key) => {
      if (HIDDEN_KEYS.has(key)) return;

      const value = data[key];
      result[key] =
        key === 'account'
          ? resolveAccount(value, accountMap)
          : sanitizeAuditSnapshot(value, accountMap);
    });
    return result;
  }

  return data;
};

export default sanitizeAuditSnapshot;
